module.exports = __webpack_public_path__ + "static/media/background.d1be16a9.mp4";